import React, { useContext } from 'react';
import PostCard from './PostCard';
import { useLanguage } from '../../locales';
import { Wrapper, PostCardsList } from './styles/RecommendedPosts.styles';
import LayoutContext from '../../hooks/LayoutContext';
const RecommendedPosts = ({ posts }) => {
  const { translation } = useLanguage();
  const { openLeftDrawer, openRightDrawer } = useContext(LayoutContext);

  if (!posts || !posts.length) return null;
  return (
    <Wrapper>
      <h3>{translation.posts.postCard.title}</h3>

      <PostCardsList
        openLeftDrawer={openLeftDrawer}
        openRightDrawer={openRightDrawer}
      >
        {posts.map((post) => (
          <PostCard key={post.contentful_id} post={post} />
        ))}
      </PostCardsList>
    </Wrapper>
  );
};

export default RecommendedPosts;
